import { connect } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { MainImage, IMainImageStoreProps, IMainImageOwnProps } from '../../components/MainImage';

/* istanbul ignore next */
function mapStateToProps(state: IApplicationState): IMainImageStoreProps {
  return {
    page: state.page,
    user: state.user,
    total: state.results.total,
    favoriteEntities: state.results.favoriteEntities,
  };
}

export const MainImageContainer = connect<IMainImageStoreProps, {}, IMainImageOwnProps>(mapStateToProps)(MainImage);
